import {
  type Sort,
  type Tab,
  validatedSort,
} from '@efdigital/ll-xceed-v2/utils/coaching/coach-profile-search';
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

const DEFAULT_TAB: Tab = 'pool';
const DEFAULT_SORT: Sort = 'combinedScore';

export default class CoachingCoacheeCohortCoachesIndexController extends Controller {
  queryParams = [
    'searchQuery',
    'sort',
    'specialty',
    'language',
    'industry',
    'country',
    'tab',
  ];

  @tracked searchQuery = '';
  @tracked sort: Sort = DEFAULT_SORT;
  @tracked specialty: string | null = null;
  @tracked language: string | null = null;
  @tracked industry: string | null = null;
  @tracked country: string | null = null;
  @tracked tab: Tab = DEFAULT_TAB;

  isActiveTab(tab: Tab): boolean {
    return this.tab === tab;
  }

  get validatedSort(): Sort {
    return validatedSort(this.sort);
  }

  setTab = (value: Tab) => {
    this.tab = value;
  };

  setSearchQuery = (value: string) => {
    this.searchQuery = value;
  };

  setSort = (value: Sort) => {
    this.sort = value;
  };

  setSpecialty = (value: string | null) => {
    this.specialty = value || null;
  };

  setLanguage = (value: string | null) => {
    this.language = value || null;
  };

  setIndustry = (value: string | null) => {
    this.industry = value || null;
  };

  setCountry = (value: string | null) => {
    this.country = value || null;
  };
}
